import { render } from "./Footer.vue?vue&type=template&id=6adf4da6&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=6adf4da6&scoped=true&lang=scss"

import exportComponent from "/Users/ckyang/dev/olabbio/sites/olab-github/gf-olab-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6adf4da6"]])

export default __exports__